import { ErrorOutlined } from '@material-ui/icons';
import axios from 'axios';
import uuidv1 from 'uuid/v1'
import Swagger from 'swagger-client'
import config from '../config'
import clientRequest from '../constants/clientRequest';
import { 
    POLLING_SCANNING_INTERVAL_MS,
    VIRUS_SCAN_CODES,
    VIRUS_SCAN_CONSTANTS,
    } from '../constants/constants';

// const clientRequest = Swagger(swaggerSpec).then(client => {
//     //   if (process.env.NODE_ENV === 'test') {
//     //     client.spec.host = 'localhost:9003';
//     //   }
//     return client;
// });
const tag = 'api/s3';

export const gets3object = (object_name, token, bucket_name) => {
    return new Promise((resolve, reject) => {
        const param = {
            "bucket_name": bucket_name,
            "object_name": object_name,
            "token": token
        }
        const request = {
            url: `${config.baseUrl}/api/s3/get_s3_object_url`,
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(param),
        };
        clientRequest.then(client=>{
        client.http(request).then(
            res => {
                resolve(res.body)
            },
            err => {
                reject(err)
            })
    })
    })
}

export const pollUntilClean = async (token, bucket, path, pollPeriod=null) => {
    /**
     * Polls the antivirus scan status of an S3 object until it is no longer pending or until the poll period expires.
     * Args:
     *  token (string): Authentication token.
     *  bucket (string): S3 bucket name.
     *  path (string): S3 object path.
     *  pollPeriod (int, optional): Maximum time to poll in seconds. Defaults to 15 minutes.
     */
    const currentTime = new Date().getTime();
    pollPeriod = parseInt(pollPeriod) || VIRUS_SCAN_CONSTANTS.MAX_POLLING_TIME; // default to 15 minutes

    while ((new Date().getTime() - currentTime < pollPeriod * 1000)) { // timeout after 15 minutes
        try {
            const client = await clientRequest;
            const args = {
                token: token,
                bucket_name: bucket,
                object_name: path,
            };

            const check = await client.apis[tag].post_check_antivirus_scan_status({
                payload: args
            });

            if (check.body.error_code === VIRUS_SCAN_CODES.PENDING) { // its pending
                await new Promise(r => setTimeout(r, POLLING_SCANNING_INTERVAL_MS));
            } else {
                return check.body;
            }
        } catch (err) {
             console.error("Error polling antivirus status:", err);
             return { error_code: -1, message: "Error polling status" };
        }
    }
    return { error_code: VIRUS_SCAN_CODES.TIMEOUT, message: "Virus scan timed out" }
};

export const gets3objectWithJobId = (object_name, token, bucket_name) => {
    return new Promise((resolve, reject) => {
        const param = {
            "bucket_name": bucket_name,
            "object_name": object_name,
            "token": token
        }
        const request = {
            url: `${config.baseUrl}/api/s3/get_s3_object_url_unsafe`,
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(param),
        };
        clientRequest.then(client=>{
        client.http(request).then(
            res => {
                resolve(res.body)
            },
            err => {
                reject(err)
            })
    })
    })
}


export const getMultipleObject = (interview_id, token) => {
    return new Promise((resolve, reject) => {
        const param = {
            "interview_id": interview_id,
        }
        const request = {
            url: "https://iudn371087.execute-api.ap-southeast-1.amazonaws.com/prod",
            //url: `localhost:8000/api/s3/download_multiple_object`,
            method: 'GET',
            query: param,
            headers: {
                'x-api-key': 'A3hrrQM8Bo7kHSlBwGfGH2MOL3RxWp6S7vHInVvq',

            },

        };

        clientRequest.then(client=>{
        client.http(request).then(
            res => {
                resolve(res.body)
            },
            err => {
                reject(err)
            })
        })
    })
}

// unused functio
export const posts3Object = (object_name, token, progressBack) => {
    return clientRequest.then(client => {
        const param = {
            "object_name": object_name,
            "token": token
        }
        const request = {
            url: `${config.baseUrl}/api/s3/create_s3_upload_url`,
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(param),
        };
        
        client.http(request).then(res => {
            progressBack(res)
        })
    })
}

export const getExists3File = (object_name, token) => {
    return new Promise((resolve, reject) => {
        gets3object(object_name, token).then(res => {
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.open("GET", res.body, false); // false for synchronous request
            xmlHttp.send();
            if (xmlHttp.status == 200) {
                resolve(res.body)
            } else {
                reject(xmlHttp)
            }
        },
            err => {
                reject(err)
            })
    })
}

export const create_upload = (object_name, token, bucket_name) => {
    return new Promise((resolve, reject) => {
        const param = {
            "bucket_name": bucket_name,
            "object_name": object_name,
            "token": token
        }
        const request = {
            url: `${config.baseUrl}/api/s3/generate_upload_id`,
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(param),
        };
        clientRequest.then(client=>{
            client.http(request).then(
                res => {
                    resolve(res)
                },
                err => {
                    reject(err)
                })
        })
    }
    )
}

export const multi_upload = (object_name, upload_id, part_no, token, bucket_name) => {
    return new Promise((resolve, reject) => {
        const param = {
            "bucket_name": bucket_name,
            "object_name": object_name,
            "upload_id": upload_id,
            "part_no": part_no,
            "token": token
        }
        const request = {
            url: `${config.baseUrl}/api/s3/upload_multipart_s3_object`,
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(param),
        };
        clientRequest.then(client=>{
            client.http(request).then(
                res => {
                    resolve(res)
                },
                err => {
                    reject(err)
                })
        })

    })
}

export const complete_upload = (object_name, upload_id, parts, token, bucket_name, candidate) => {
    return new Promise((resolve, reject) => {
        const param = {
            "candidate": candidate === "yes" ? "yes" : "no",
            "bucket_name": bucket_name,
            "object_name": object_name,
            "parts": parts,
            "token": token,
            "upload_id": upload_id
        }
        const request = {
            url: `${config.baseUrl}/api/s3/complete_multipart_s3_upload`,
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(param),
        };
        // console.log(request, "_____+++++======+_________")
        clientRequest.then(client=>{
            client.http(request).then(
                res => {
                    resolve(res)
                },
                err => {
                    reject(err)
                })
        })

    })
}

export const s3_upload_object_url = (token, bucket_name, object_name, blob) => {
    return new Promise((resolve, reject) => {
        var data = new FormData()
        data.append("token",token)
        data.append("bucket_name",bucket_name)
        data.append("object_name",object_name)
        data.append("object_file",blob)
        const request = {
            url: `${config.baseUrl}/api/s3/put_s3_object_url`,
            method: 'POST',
            body: data
        };
        clientRequest.then(client=>{
            client.http(request).then(
                res => {
                    resolve(res)
                },
                err => {
                    reject(err)
                })
        })
        
    })
}

export const create_s3_upload_url_simple = async (token, bucket_name, object_name, blob = null, content_type = null) => {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("bucket_name", bucket_name);
    formData.append("object_name", object_name);

    if (content_type != null) {
        formData.append("content_type", content_type);
    }
    const request = {
        url: `${config.baseUrl}/api/s3/create_s3_upload_url_simple`,
        method: 'POST',
        body: formData,
    };
    return clientRequest.then(client=>client.http(request))
}

export const fetch_get_s3_object_url = (args) => {
  return clientRequest.then((client) => {
    return client.apis[tag].post_get_s3_object_urlapi({
      payload: args
    })
  })
}

export const checkS3ObjectExists = (token, bucket_name, object_name) => {
  return clientRequest.then((client) => {
    return client.apis[tag].post_check_object_exists(
        {
            payload: {
            token,
            bucket_name,
            object_name
            }
        }
    )
  })
}

export const processSimpleVideoUploadApi = (token, bucket_name, object_name) => {
    return clientRequest.then((client) => {
        return client.apis[tag].post_process_simple_video_upload(
            {
                payload: {
                    token,
                    bucket_name,
                    object_name
                }
            }
        )
    })
}

export const createS3UploadPresignedURL = (payload) => {
    return clientRequest.then((client) => {
        return client.apis[tag].post_create_simple_presigned_url({
        payload: payload
        })
    })
}

export const upload_file_to_s3_simple = async (token, bucket_name, object_name, blob, content_type = null) => {
    try {
        const res = await create_s3_upload_url_simple(bucket_name, blob, object_name, token, content_type);
        return await uploadToS3(blob, res);
    } catch (error) {
        console.error("upload_file_to_s3_simple error:", error);
        throw error;
    }
};

export const uploadToS3 = async (blob, res) => {
    try {
      if (!res || !res.obj || !res.obj.fields || !res.obj.url) {
        throw new Error("Invalid S3 upload response format")
      }

      const formData = new FormData()
      Object.entries(res.obj.fields).forEach(([key, values]) => {
        formData.append(key, values);
      })

      if (blob.type) {
        formData.append('Content-Type', blob.type)
      }

      formData.append('file', blob)
      
      const response = await axios.post(res.obj.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      
      if (response.status >= 200 && response.status < 300) {
        console.log("InterviewPractice: S3 upload successful")
        return true
      } else {
        throw new Error(`S3 upload failed with status: ${response.status}`)
      }
    } catch (err) {
        console.error("InterviewPractice: S3 upload error:", err)
        return false
    }
}

const s3access = {
    gets3object,
    posts3Object,
    getExists3File,
    create_upload,
    multi_upload,
    complete_upload,
    create_s3_upload_url_simple,
    s3_upload_object_url,
    checkS3ObjectExists,
    processSimpleVideoUploadApi,
    createS3UploadPresignedURL,
    upload_file_to_s3_simple,
    uploadToS3,
};

export default s3access;
